import Iconify, { IconifyProps } from '@components/iconify';
import { Box, ToggleButton, Typography } from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';

interface PreferenceOption {
  key: string;
  label: string;
  icon: IconifyProps;
}

interface PreferenceCardGridProps {
  options: readonly PreferenceOption[];
  selectedKeys: string[];
  onToggle: (key: string) => void;
  singleRow?: boolean;
}

export default function PreferenceCardGrid({
  options,
  selectedKeys,
  onToggle,
  singleRow = false,
}: PreferenceCardGridProps) {
  const isMobile = useResponsive('down', 'sm');

  if (isMobile) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, width: '100%' }}>
        {options.map((option) => (
          <ToggleButton
            key={option.key}
            value={option.key}
            color="secondary"
            selected={selectedKeys.includes(option.key)}
            onChange={() => onToggle(option.key)}
            fullWidth
            sx={{ gap: 1, py: 1, px: 2 }}
          >
            <Iconify icon={option.icon} width={18} />
            <Typography variant="body2" fontWeight={500} color="inherit">
              {option.label}
            </Typography>
          </ToggleButton>
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: singleRow ? 'nowrap' : 'wrap',
        justifyContent: 'center',
        gap: 2,
        maxWidth: singleRow ? 'none' : 609,
      }}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.key}
          value={option.key}
          selected={selectedKeys.includes(option.key)}
          onChange={() => onToggle(option.key)}
          sx={{
            width: 191,
            height: 204,
            p: 3,
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: 7,
          }}
        >
          <Iconify icon={option.icon} width={28} />
          <Typography
            variant="h4"
            component="span"
            sx={{ display: 'block', width: '100%', textAlign: 'left', lineHeight: 1, color: 'text.primary' }}
          >
            {option.label}
          </Typography>
        </ToggleButton>
      ))}
    </Box>
  );
}
